module.exports = __webpack_public_path__ + "static/img/VDscenario2.23e28b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wap/VDscenario2.png
// module id = 6i1+
// module chunks = 0